import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="flex flex-col items-center justify-center p-4 bg-red-600 text-white rounded-lg shadow-lg animate-pulse my-4 max-w-md mx-auto w-full border-4 border-red-800" data-id="element-3">
      <div className="flex items-center gap-2 mb-1" data-id="element-4">
        <Clock className="w-5 h-5" data-id="element-5" />
        <span className="font-bold uppercase tracking-wider text-sm" data-id="element-6">
          La oferta expira en:
        </span>
      </div>
      <div className="text-5xl font-black font-mono tracking-widest" data-id="element-7">
        {formattedTime}
      </div>
      {timeLeft === 0 && <div className="mt-2 font-bold text-yellow-300" data-id="element-8">OFERTA EXPIRADA</div>}
    </div>;
}